var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-hover',[_c('v-btn',_vm._g(_vm._b({staticClass:"close-button",attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.$emit('close')}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("$vuetify.icons.cancel")])],1)],1)]}}])},[_c('span',{domProps:{"textContent":_vm._s(_vm.tooltip ? _vm.tooltip : _vm.$t('close'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }